/**
 * Deep links: #hub, #chat, #sec-chat (alias) — fragment după #.
 */

export function parseRouteHash(): { kind: 'hub' } | { kind: 'section'; name: string } | null {
    const raw = window.location.hash.replace(/^#/, '').trim();
    if (!raw) return null;
    try {
        let h = decodeURIComponent(raw).trim().toLowerCase();
        if (h === 'hub') return { kind: 'hub' };
        if (h.startsWith('sec-')) h = h.slice(4);
        if (!/^[a-z0-9_-]+$/i.test(h)) return null;
        return { kind: 'section', name: h };
    } catch {
        return null;
    }
}

/** Sincronizează bara de adresă fără reîncărcare (bookmark / share). */
export function setRouteHash(token: 'hub' | string): void {
    const hash = token === 'hub' ? '#hub' : `#${token}`;
    const path = `${window.location.pathname}${window.location.search}${hash}`;
    if (`${window.location.pathname}${window.location.search}${window.location.hash}` === path) return;
    history.replaceState(null, '', path);
}

/** După închidere Hub: hash = secțiunea `.section.active`. */
export function syncHashToActiveSection(): void {
    const active = document.querySelector('.section.active') as HTMLElement | null;
    const id = active?.id || '';
    if (id.startsWith('sec-')) {
        setRouteHash(id.slice(4));
    } else {
        setRouteHash('dashboard');
    }
}
